import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import ConfirmationOptionLabel from '../../../fulfillment-planner/confirmation-option/label';
import InsuranceOptionLabel from '../../../fulfillment-planner/insurance-option/label';
import { PickupLabel as Pickup } from '../../../fulfillment-planner/local-delivery/pickup/label';
import Package from '../../../fulfillment-planner/package/label';
import RequestedShippingService from '../../../fulfillment-planner/requested-shipping-service/label';
import ShipFrom from '../../../fulfillment-planner/ship-from/label';
import ShippingService from '../../../fulfillment-planner/shipping-service/label';
import Weight from '../../../fulfillment-planner/weight/label';
import { isCentimeters } from '../../../services/unit-services/dimensions/dimension-type-service';

export const ConfirmationLabel = <ConfirmationOptionLabel />;
export const InsuranceLabel = <InsuranceOptionLabel />;
export const InsuranceAmountLabel = <FormattedMessage {...messages.insureAmount} />;
export const PackageLabel = <Package />;
export const RequestedShippingServiceLabel = <RequestedShippingService />;
export const ShipFromLabel = <ShipFrom />;
export const ReturnToLabel = <FormattedMessage {...messages.returnTo} />;
export const ShippingServiceLabel = <ShippingService />;
export const WeightLabel = <Weight />;
export const TrackingStatusLabel = <FormattedMessage {...messages.trackingStatus} />;
export const FulfillmentProviderLabel = <FormattedMessage {...messages.fulfillmentProvider} />;
export const ExternalFulfillmentCarrierLabel = <FormattedMessage {...messages.externalFulfillmentCarrier} />;
export const DelegationDateLabel = <FormattedMessage {...messages.delegationDate} />;
export const RateLabel = <FormattedMessage {...messages.rate} />;
export const ShipDateLabel = <FormattedMessage {...messages.shipDate} />;
export const TrackingNumberLabel = <FormattedMessage {...messages.trackingNumber} />;
export const PickupLabel = <Pickup />;

export const SizeLabel = ({ dimensionUnit }) => {
  const labelValues = useMemo(() => {
    const isMetric = isCentimeters(dimensionUnit);

    return { isMetric };
  }, [dimensionUnit]);

  return <FormattedMessage {...messages.sizeLabel} values={labelValues} />;
};

SizeLabel.propTypes = {
  dimensionUnit: PropTypes.string.isRequired,
};
